export const EVALUTE_ROUTE = '/api/v1/evaluate';
export const BATCH_EVALUATE_ROUTE = '/api/v1/batch-evaluate';
